import PropTypes from 'prop-types';
import React from 'react';
import Image from '$partials/media/image';


const PersonItem = ({
    image,
    index,
    title,
    role,
    url,
}) => {
    return (
        <div className='expand-interaction py-20 md:py-30 layout-grid-col-padding basis-6/12 sm:basis-3/12 md:basis-2/11'>
            <Image
                {...image}
                alt={`Image of ${title}`}
                key={index} />
            <h3 className='type-style-3 pb-5 pt-25'>
                <a
                    className='expand-interaction__action'
                    href={url}>
                    {title}
                </a>
            </h3>
            <p className='type-style-4'>{role}</p>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    image: PropTypes.object,
    index: PropTypes.number,
    role: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
};

PersonItem.propTypes = propTypes;

export default PersonItem;
